import { FC } from "react";

// * Components
import { RutubeFormProps } from "./RutubeForm.interface";
import PlatformInstruction from "../PlatformInstruction";
import { InputField } from "../../InputField";
import InputLegend from "../../InputLegend";

// * Hooks
import { useForm, SubmitHandler } from "react-hook-form";
import {
  CreateRutubeQueryBody,
  useCreateRutubeChannelMutation
} from "../../../features/api/apiSlice";

// * Styles
import styles from "./RutubeForm.module.css";
import { Error } from "../../Error";

const QUERY_TARGET_URL_ERROR_MESSAGE = "Неверный URL канала";
const QUERY_KEY_ERROR_MESSAGE = "Неверный ключ потока";

export const RutubeForm: FC<RutubeFormProps> = ({
  id,
  selectedPlatform,
  closePopup
}) => {
  const [createRutubeChannel] = useCreateRutubeChannelMutation();
  const {
    register,
    formState: { errors },
    handleSubmit,
    setError,
    clearErrors
  } = useForm<CreateRutubeQueryBody>({
    mode: "onSubmit"
  });

  const addRutubeChannel: SubmitHandler<CreateRutubeQueryBody> = (rutubeFormBody) => {
    createRutubeChannel(rutubeFormBody)
      .unwrap()
      .then(() => {
        closePopup();
      })
      .catch((error: any) => {
        const errors = error?.data?.errors;

        if (errors?.includes("INVALID_TARGET_URL")) {
          setError("target_url", {
            type: "validate",
            message: QUERY_TARGET_URL_ERROR_MESSAGE
          });
        } else if (errors?.includes("INVALID_KEY")) {
          setError("key", {
            type: "validate",
            message: QUERY_KEY_ERROR_MESSAGE
          });
        }
      });
  };

  const getErrorsString = () => {
    return Object.values(errors)
      .map(({ message }) => message)
      .join(" ");
  };

  return (
    <>
      <form
        id={id}
        onSubmit={handleSubmit(addRutubeChannel)}
        className={styles["rutube-form"]}
      >
        <PlatformInstruction
          selectedPlatform={selectedPlatform}
          className={styles["rutube-form__instruction"]}
        />
        <InputLegend legend='Ссылка на канал'>
          <InputField
            type="text"
            isError={Boolean(errors.channel_link?.message)}
            placeholder="https://rutube.ru/channel/example_id/"
            {...register("channel_link", {
              required: "Введите, пожалуйста, ссылку на канал.",
              pattern: {
                value: /^https:\/\/rutube\.ru\/channel\/[0-9_-]+\/$/,
                message: "Неправильная ссылка."
              }
            })}
            onInput={() => clearErrors()}
            autoComplete="off"
          />
        </InputLegend>
        <InputLegend legend='URL канала'>
          <InputField
            type="text"
            isError={Boolean(errors.target_url?.message)}
            placeholder="rtmp://example.com/live*"
            {...register("target_url", {
              required: "Введите, пожалуйста, URL канала.",
            })}
            onInput={() => clearErrors()}
            autoComplete="off"
          />
        </InputLegend>
        <InputLegend legend='Ключ'>
          <InputField
            type="password"
            isError={Boolean(errors.key?.message)}
            placeholder="Ключ сервера"
            {...register("key", {
              required: "Введите, пожалуйста, ключ сервера.",
              validate: (value) => {
                if (!value.trim()) {
                  return "Введите, пожалуйста, ключ сервера.";
                }
              }
            })}
            onInput={() => clearErrors()}
            autoComplete="off"
          />
        </InputLegend>
      </form>

      <Error className={styles["rutube-form__error-container"]}>{getErrorsString()}</Error>
    </>
  );
};
